import React, { useState, useEffect } from "react"

//import components
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  CardTitle,
  Container,
  FormFeedback,
} from "reactstrap"
import Select from "react-select"
import Dropzone from "react-dropzone"
import { Link, useNavigate } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { createEvent } from "../../../redux/actions/event"
import { fetchCategories } from "../../../redux/actions/event"
import SuccessPopup from "../../../components/SuccessPopup"
import ErrorPopup from "../../../components/ErrorPopup"

const eventTypeOptions = [
  {
    options: [
      {
        label: "Networking Meet",
        value: "netwoking-meet",
      },
      {
        label: "Anniversary Meet",
        value: "anniversary-meet",
      },
      {
        label: "Competition",
        value: "competition",
      },
    ],
  },
]

function AddEvent() {
  document.title = "Add Event | Event | Admin Dashboard"

  const history = useNavigate()
  const dispatch = useDispatch()

  const createEventState = useSelector(state => state.screens.event.createEvent)
  const categoriesState = useSelector(
    state => state.screens.event.fetchCategories
  )
    const token = useSelector(state => state.auth.token)

  const [selectedFiles, setselectedFiles] = useState([])
  const [tags, setTags] = useState([])
  const [tagInput, setTagInput] = useState("")
  const [successOpen, setSuccessOpen] = useState(false)
  const [errorOpen, setErrorOpen] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [bannerUploading, setBannerUploading] = useState(false)
  const [bannerUploadError, setBannerUploadError] = useState("")

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: "",
      category: "",
      event_type: "",
      schedule: [
        { date: "", start: "", end: "" }, // one empty row to begin
      ],
      google_address: "",
      address: "",
      landmark: "",
      status: "",
      description_about: "",
      description_iternary: "",
      description_inclusions: "",
      description_exclusions: "",
      only_pvs: 1, // Default to 1 (Yes)
      is_featured: 1, // Default to 1 (Yes)
      banner: "",
      tags: "",
      tickets: [
        { title: "", cost: "", seats: "", is_child: "" }, // one empty row to begin
      ],
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Your Title"),
      status: Yup.string().required("Please Select Status"),
      banner: Yup.string().required("Please Upload Banner"),
      category: Yup.string().required("Please Select Category"),
      event_type: Yup.object().required("Please Select Event Type"),
      // address: Yup.string().required("Please Enter Address"),
      // description_about: Yup.string().required("Please Enter About Event "),
      schedule: Yup.array().of(
        Yup.object({
          date: Yup.string().required("Pick a date"),
          // start: Yup.string().required("Start time"),
          // end: Yup.string().required("End time"),
        })
      ),
      tickets: Yup.array().of(
        Yup.object({
          title: Yup.string().required("Please Enter Ticket Type"),
          cost: Yup.string().required("Please Enter Ticket Cost"),
          seats: Yup.string().required("Please Enter Number Of Ticket"),
          is_child: Yup.string().required("Please Select Is Child"),
          // start: Yup.string().required("Start time"),
          // end: Yup.string().required("End time"),
        })
      ),
    }),
    onSubmit: values => {
      // Use the uploaded banner filename if available
      const bannerFilename =
        values.banner ||
        (selectedFiles[0] && selectedFiles[0].serverFilename) ||
        ""
      // Format date as '30 Jun 2025' and time as '12:00PM'
      function formatDate(dateStr) {
        if (!dateStr) return ""
        const dateObj = new Date(dateStr)
        if (isNaN(dateObj)) return dateStr // fallback if invalid
        const day = dateObj.getDate()
        const month = dateObj.toLocaleString("en-US", { month: "short" })
        const year = dateObj.getFullYear()
        return `${day < 10 ? "0" + day : day} ${month} ${year}`
      }
      function formatTime(timeStr) {
        if (!timeStr) return ""
        // timeStr is '14:28' or '12:00', convert to '12:00PM'
        const [h, m] = timeStr.split(":")
        let hour = parseInt(h, 10)
        const min = m
        const ampm = hour >= 12 ? "PM" : "AM"
        hour = hour % 12
        if (hour === 0) hour = 12
        return `${hour < 10 ? "0" + hour : hour}:${min}${ampm}`
      }
      // Format date as 'YYYY-MM-DD HH:mm:ss' for event_date
      function formatEventDate(dateStr, timeStr) {
        if (!dateStr) return ""
        const dateObj = new Date(dateStr)
        if (isNaN(dateObj)) return dateStr
        let hours = 0
        let minutes = 0
        if (timeStr) {
          const [h, m] = timeStr.split(":")
          hours = parseInt(h, 10)
          minutes = parseInt(m, 10)
        }
        dateObj.setHours(hours, minutes, 0, 0)
        const yyyy = dateObj.getFullYear()
        const mm = String(dateObj.getMonth() + 1).padStart(2, "0")
        const dd = String(dateObj.getDate()).padStart(2, "0")
        const HH = String(dateObj.getHours()).padStart(2, "0")
        const MM = String(dateObj.getMinutes()).padStart(2, "0")
        return `${yyyy}-${mm}-${dd} ${HH}:${MM}:00`
      }
      const schedules = (values.schedule || []).map(sch => ({
        date: formatDate(sch.date),
        start: formatTime(sch.start),
        end: formatTime(sch.end),
      }))
      // event_date in 'YYYY-MM-DD HH:mm:ss' using first schedule's date and start time
      let event_date = ""
      if (values.schedule && values.schedule.length > 0) {
        event_date = formatEventDate(
          values.schedule[0].date,
          values.schedule[0].start
        )
      }
      // Convert schedules array to stringified format with single quotes as required
      let schedulesString = JSON.stringify(schedules)
      // schedulesString = schedulesString.replace(/"/g, "'")
      // Convert is_child 'yes'/'no' to 1/0 for all tickets
      const tickets = (values.tickets || []).map(ticket => ({
        ...ticket,
        is_child:
          ticket.is_child === "yes"
            ? 1
            : ticket.is_child === "no"
            ? 0
            : ticket.is_child,
      }))
      // Convert only_pvs and is_featured from Yes/No to 1/0
      let only_pvs = values.only_pvs
      if (only_pvs === "Yes" || only_pvs === 1)
        only_pvs = 1
      else if (only_pvs === "No" || only_pvs === 0)
        only_pvs = 0
      let is_featured = values.is_featured
      if (is_featured === "Yes" || is_featured === 1) is_featured = 1
      else if (is_featured === "No" || is_featured === 0) is_featured = 0
      const data = {
        ...values,
        event_type: values.event_type?.value || "",
        banner: bannerFilename,
        category_id: values.category, // Pass category as category_id
        schedules: schedulesString, // Pass schedule as stringified schedules with single quotes
        event_date: event_date, // Set event_date as first schedule date
        address: values.full_address, // Pass full_address as address
        latitude: "", // Add empty latitude
        longitude: "", // Add empty longitude
        tickets, // Use converted tickets array
        only_pvs, // Always 1 or 0
        is_featured, // Always 1 or 0
      }
      delete data.category // Remove the original category field
      delete data.schedule // Remove the original schedule field
      delete data.full_address // Remove the original full_address field
      handleSubmit(data)
    },
  })

  // Map categories to Select options
  const categoryOptions = (categoriesState.categories || []).map(cat => ({
    value: cat.id,
    label: cat.title,
  }))

  const handleSubmit = value => {
    dispatch(createEvent(value))
  }

  // Handle adding a new tag
  const addTag = e => {
    if (e.key === " " && tagInput.trim() !== "") {
      e.preventDefault()
      const newTag = tagInput.trim()
      if (!tags.includes(newTag)) {
        const newTags = [...tags, newTag]
        setTags(newTags)
        validation.setFieldValue("tags", newTags.join(", "))
      }
      setTagInput("")
    }
  }

  // Handle removing a tag
  const removeTag = indexToRemove => {
    const newTags = tags.filter((_, index) => index !== indexToRemove)
    setTags(newTags)
    validation.setFieldValue("tags", newTags.join(", "))
  }

  // Handle backspace to remove last tag
  const handleKeyDown = e => {
    if (e.key === "Backspace" && tagInput === "" && tags.length > 0) {
      removeTag(tags.length - 1)
    }
  }

  async function handleAcceptedFiles(files) {
    if (!files || files.length === 0) return
    setBannerUploading(true)
    setBannerUploadError("")
    const file = files[0]
    const formData = new FormData()
    formData.append("banner", file)
    fetch(`${process.env.REACT_APP_API_URL}/dashboard/upload-event-banner`, {
      method: "POST",
      body: formData,      
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(async response => {
        if (!response.ok) throw new Error("Banner upload failed")
        const data = await response.json()
        if (data.success && data.filename) {
          // Set Formik's banner field to the filename
          validation.setFieldValue("banner", data.filename)
          // For preview
          file.preview = URL.createObjectURL(file)
          file.formattedSize = formatBytes(file.size)
          file.serverFilename = data.filename // Save filename for later use
          setselectedFiles([file])
        } else {
          throw new Error(data.message || "Banner upload failed")
        }
        setBannerUploading(false)
      })
      .catch(err => {
        setBannerUploading(false)
        setBannerUploadError(err.message || "Banner upload failed")
        setselectedFiles([])
      })
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  const emptyScheduleRow = { date: "", start: "", end: "" }
  const emptyTicketsRow = { title: "", cost: "", seats: "", is_child: "" }

  const addScheduleRow = () => {
    validation.setFieldValue("schedule", [
      ...validation.values.schedule,
      emptyScheduleRow,
    ])
  }

  const deleteScheduleRow = index => {
    const newRows = [...validation.values.schedule]
    newRows.splice(index, 1)
    validation.setFieldValue("schedule", newRows)
  }

  const addTicketsRow = () => {
    validation.setFieldValue("tickets", [
      ...validation.values.tickets,
      emptyTicketsRow,
    ])
  }

  const deleteTicketsRow = index => {
    const newRows = [...validation.values.tickets]
    newRows.splice(index, 1)
    validation.setFieldValue("tickets", newRows)
  }

  useEffect(() => {
    if (validation.values.tags) {
      const initialTags = validation.values.tags
        .split(",")
        .map(tag => tag.trim())
        .filter(tag => tag !== "")
      setTags(initialTags)
    }
  }, [validation.values.tags])

  useEffect(() => {
    if (createEventState && createEventState.success) {
      setSuccessOpen(true)
    } else if (createEventState && createEventState.error) {
      setErrorMsg(createEventState.message || "Unable to add event form.")
      setErrorOpen(true)
    }
  }, [createEventState])

  useEffect(() => {
    dispatch(fetchCategories())
  }, [dispatch])

  return (
    <React.Fragment>
      <SuccessPopup
        isOpen={successOpen}
        toggle={() => setSuccessOpen(false)}
        onConfirm={() => {
          setSuccessOpen(false)
          history("/events/upcoming-list", { replace: true })
        }}
        message={"Event added successfully!"}
      />
      <ErrorPopup
        isOpen={errorOpen}
        toggle={() => setErrorOpen(false)}
        message={errorMsg}
      />
      <div className="page-content">
        <Container fluid={true}>
          <div className="mb-3 pb-2"></div>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="flex-grow-1">
              <h2 className="h4 nom-title mb-0">Add & Edit Events</h2>
            </div>
          </div>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {/* <CardTitle className="h4">Nested</CardTitle> */}
                  {/* <Form className="outer-repeater"> */}
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="title">
                          Title
                        </Label>
                        <Input
                          name="title"
                          className="form-control"
                          placeholder="Enter Title"
                          type="text"
                          id="title"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.title || ""}
                          invalid={
                            validation.touched.title && validation.errors.title
                              ? true
                              : false
                          }
                        />
                        {validation.touched.title && validation.errors.title ? (
                          <FormFeedback type="invalid">
                            {validation.errors.title}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="category">
                          Category
                        </Label>

                        <Select
                          id="category"
                          name="category"
                          value={
                            categoryOptions.find(
                              option =>
                                option.value === validation.values.category
                            ) || null
                          }
                          onChange={selectedOption => {
                            validation.setFieldValue(
                              "category",
                              selectedOption ? selectedOption.value : ""
                            )
                          }}
                          onBlur={validation.handleBlur}
                          options={categoryOptions}
                          classNamePrefix="select2-selection"
                          className={
                            validation.touched.category &&
                            validation.errors.category
                              ? "is-invalid"
                              : ""
                          }
                        />
                        {validation.touched.category &&
                        validation.errors.category ? (
                          <FormFeedback className="d-block" type="invalid">
                            {validation.errors.category}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    <div className="mb-3 col-md-6">
                      <Label className="form-label" htmlFor="event_type">
                        Event Type
                      </Label>

                      <Select
                        id="event_type"
                        name="event_type"
                        value={validation.values.event_type}
                        onChange={selectedOption => {
                          validation.setFieldValue(
                            "event_type",
                            selectedOption
                          )
                        }}
                        options={eventTypeOptions}
                        classNamePrefix="select2-selection"
                        className={
                          validation.touched.event_type &&
                          validation.errors.event_type
                            ? "is-invalid"
                            : ""
                        }
                      />
                      {validation.touched.event_type &&
                        validation.errors.event_type && (
                          <FormFeedback className="d-block" type="invalid">
                            {validation.errors.event_type}
                          </FormFeedback>
                        )}
                    </div>

                    <CardTitle className="h4">Event Schedule</CardTitle>

                    {validation.values.schedule.map((row, idx) => (
                      <div className="row mb-3" key={idx}>
                        <div className="col-lg-3 mb-3 mb-lg-0">
                          <label className="form-label">Event Date</label>
                          <input
                            type="date"
                            className={`form-control ${
                              validation.touched.schedule?.[idx]?.date &&
                              validation.errors.schedule?.[idx]?.date
                                ? "is-invalid"
                                : ""
                            }`}
                            {...validation.getFieldProps(
                              `schedule.${idx}.date`
                            )}
                          />
                          <div className="invalid-feedback">
                            {validation.errors.schedule?.[idx]?.date}
                          </div>
                        </div>

                        <div className="col-lg-3 mb-3 mb-lg-0">
                          <label className="form-label">Start Time</label>
                          <input
                            type="time"
                            className={`form-control ${
                              validation.touched.schedule?.[idx]?.start &&
                              validation.errors.schedule?.[idx]?.start
                                ? "is-invalid"
                                : ""
                            }`}
                            {...validation.getFieldProps(
                              `schedule.${idx}.start`
                            )}
                          />
                          <div className="invalid-feedback">
                            {validation.errors.schedule?.[idx]?.start}
                          </div>
                        </div>

                        <div className="col-lg-3 mb-3 mb-lg-0">
                          <label className="form-label">End Time</label>
                          <input
                            type="time"
                            className={`form-control ${
                              validation.touched.schedule?.[idx]?.end &&
                              validation.errors.schedule?.[idx]?.end
                                ? "is-invalid"
                                : ""
                            }`}
                            {...validation.getFieldProps(`schedule.${idx}.end`)}
                          />
                          <div className="invalid-feedback">
                            {validation.errors.schedule?.[idx]?.end}
                          </div>
                        </div>

                        {/* Right-side Button Column */}
                        <Col lg={2} className="align-self-center d-grid mt-4">
                          {idx === 0 ? (
                            <Button
                              type="button"
                              color="success"
                              onClick={addScheduleRow}
                            >
                              Add More Schedule
                            </Button>
                          ) : (
                            <Button
                              type="button"
                              color="danger"
                              onClick={() => deleteScheduleRow(idx)}
                            >
                              Delete
                            </Button>
                          )}
                        </Col>
                      </div>
                    ))}

                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="google_address">
                          Search Google Location
                        </Label>
                        <Input
                          name="google_address"
                          className="form-control"
                          placeholder="Enter Google Location"
                          type="text"
                          id="google_address"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.google_address || ""}
                          invalid={
                            validation.touched.google_address &&
                            validation.errors.google_address
                              ? true
                              : false
                          }
                        />
                        {validation.touched.google_address &&
                        validation.errors.google_address ? (
                          <FormFeedback type="invalid">
                            {validation.errors.google_address}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="full_address">
                          Full Address
                        </Label>
                        <Input
                          name="full_address"
                          className="form-control"
                          placeholder="Enter Full Address"
                          type="text"
                          id="full_address"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.full_address || ""}
                          invalid={
                            validation.touched.full_address &&
                            validation.errors.full_address
                              ? true
                              : false
                          }
                        />
                        {validation.touched.full_address &&
                        validation.errors.full_address ? (
                          <FormFeedback type="invalid">
                            {validation.errors.full_address}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="landmark">
                          Landmark
                        </Label>
                        <Input
                          name="landmark"
                          className="form-control"
                          placeholder="Enter Landmark"
                          type="text"
                          id="landmark"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.landmark || ""}
                          invalid={
                            validation.touched.landmark &&
                            validation.errors.landmark
                              ? true
                              : false
                          }
                        />
                        {validation.touched.landmark &&
                        validation.errors.landmark ? (
                          <FormFeedback type="invalid">
                            {validation.errors.landmark}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="status">
                          Status
                        </Label>

                        <Select
                          id="status"
                          name="status"
                          value={
                            [
                              { value: 1, label: "Active" },
                              { value: 0, label: "Disabled" },
                            ].find(
                              option =>
                                option.value === validation.values.status
                            ) || null
                          }
                          onChange={selectedOption => {
                            validation.setFieldValue(
                              "status",
                              selectedOption ? selectedOption.value : ""
                            )
                          }}
                          onBlur={validation.handleBlur}
                          options={[
                            { value: 1, label: "Active" },
                            { value: 0, label: "Disabled" },
                          ]}
                          classNamePrefix="select2-selection"
                          className={
                            validation.touched.status &&
                            validation.errors.status
                              ? "is-invalid"
                              : ""
                          }
                        />
                        {validation.touched.status &&
                          validation.errors.status && (
                            <FormFeedback className="d-block" type="invalid">
                              {validation.errors.status}
                            </FormFeedback>
                          )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="description_about"
                        >
                          1. What is the event about?
                        </Label>

                        <textarea
                          name="description_about"
                          id="description_about"
                          className={`form-control ${
                            validation.touched.description_about &&
                            validation.errors.description_about
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description_about || ""}
                        />

                        {validation.touched.description_about &&
                        validation.errors.description_about ? (
                          <FormFeedback type="invalid">
                            {validation.errors.description_about}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="description_iternary"
                        >
                          2. Event Itinerary
                        </Label>

                        <textarea
                          name="description_iternary"
                          id="description_iternary"
                          className={`form-control ${
                            validation.touched.description_iternary &&
                            validation.errors.description_iternary
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description_iternary || ""}
                        />

                        {validation.touched.description_iternary &&
                        validation.errors.description_iternary ? (
                          <FormFeedback type="invalid">
                            {validation.errors.description_iternary}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="description_inclusions"
                        >
                          3. Inclusions
                        </Label>

                        <textarea
                          name="description_inclusions"
                          id="description_inclusions"
                          className={`form-control ${
                            validation.touched.description_inclusions &&
                            validation.errors.description_inclusions
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description_inclusions || ""}
                        />

                        {validation.touched.description_inclusions &&
                        validation.errors.description_inclusions ? (
                          <FormFeedback type="invalid">
                            {validation.errors.description_inclusions}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="description_exclusions"
                        >
                          4. Exclusions
                        </Label>

                        <textarea
                          name="description_exclusions"
                          id="description_exclusions"
                          className={`form-control ${
                            validation.touched.description_exclusions &&
                            validation.errors.description_exclusions
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description_exclusions || ""}
                        />

                        {validation.touched.description_exclusions &&
                        validation.errors.description_exclusions ? (
                          <FormFeedback type="invalid">
                            {validation.errors.description_exclusions}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label d-flex">
                          This is a PULA Verifies Seller (PVS) Only event
                        </Label>

                        {["Yes", "No"].map((option, index) => (
                          <div
                            className="form-check form-check-inline"
                            key={index}
                          >
                            <input
                              className={`form-check-input ${
                                validation.touched.only_pvs &&
                                validation.errors.only_pvs
                                  ? "is-invalid"
                                  : ""
                              }`}
                              type="radio"
                              id={`only_pvs_${index}`}
                              name="only_pvs"
                              value={option}
                              checked={
                                validation.values.only_pvs === option
                              }
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`only_pvs_${index}`}
                            >
                              {option}
                            </label>
                          </div>
                        ))}

                        {validation.touched.only_pvs &&
                          validation.errors.only_pvs && (
                            <div className="invalid-feedback d-block">
                              {validation.errors.only_pvs}
                            </div>
                          )}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label d-flex">
                          Is event Featured on Homepage
                        </Label>

                        {["Yes", "No"].map((option, index) => (
                          <div
                            className="form-check form-check-inline"
                            key={index}
                          >
                            <input
                              className={`form-check-input ${
                                validation.touched.is_featured &&
                                validation.errors.is_featured
                                  ? "is-invalid"
                                  : ""
                              }`}
                              type="radio"
                              id={`is_featured_${index}`}
                              name="is_featured"
                              value={option}
                              checked={validation.values.is_featured === option}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`is_featured_${index}`}
                            >
                              {option}
                            </label>
                          </div>
                        ))}

                        {validation.touched.attended_events &&
                          validation.errors.attended_events && (
                            <div className="invalid-feedback d-block">
                              {validation.errors.attended_events}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="banner">
                          Event Banner
                        </Label>
                        <Dropzone
                          onDrop={acceptedFiles => {
                            handleAcceptedFiles(acceptedFiles)
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                              <div
                                className="dz-message needsclick"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="mb-3">
                                  <i className="mdi mdi-cloud-upload display-4 text-muted"></i>
                                </div>
                                <h4>Drop files here or click to upload.</h4>
                                <div
                                  className="text-muted mb-2"
                                  style={{ fontSize: "0.55em" }}
                                >
                                  Banner size must be <b>416 × 208 px</b>
                                </div>
                                {bannerUploading && (
                                  <div
                                    className="text-info mt-2"
                                    style={{ fontSize: "0.55em" }}
                                  >
                                    Uploading banner...
                                  </div>
                                )}
                                {bannerUploadError && (
                                  <div
                                    className="text-danger mt-2"
                                    style={{ fontSize: "0.55em" }}
                                  >
                                    {bannerUploadError}
                                  </div>
                                )}
                                {validation.values.banner && (
                                  <div
                                    className="text-success mt-2"
                                    style={{ fontSize: "0.55em" }}
                                  >
                                    Banner uploaded: {validation.values.banner}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div
                          className="dropzone-previews mt-3"
                          id="file-previews"
                        >
                          {selectedFiles.map((f, i) => {
                            return (
                              <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}
                              >
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                    <Col>
                                      <Link
                                        to="#"
                                        className="text-muted font-weight-bold"
                                      >
                                        {f.name}
                                      </Link>
                                      <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            )
                          })}
                        </div>
                        {/* Hidden input for formik banner value */}
                        <input
                          type="hidden"
                          name="banner"
                          value={validation.values.banner || ""}
                        />
                        {validation.touched.banner &&
                        validation.errors.banner ? (
                          <div className="invalid-feedback d-block">
                            {validation.errors.banner}
                          </div>
                        ) : null}
                      </div>

                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="tags">
                          Event Tags (Press space to add a tag)
                        </Label>
                        <div
                          className="form-control"
                          style={{
                            minHeight: "42px",
                            padding: "0.25rem 0.5rem",
                          }}
                        >
                          <div className="d-flex flex-wrap align-items-center">
                            {tags.map((tag, index) => (
                              <div
                                key={index}
                                className="badge bg-primary me-1 mb-1 d-flex align-items-center"
                              >
                                {tag}
                                <button
                                  type="button"
                                  className="btn-close btn-close-white ms-1"
                                  style={{ fontSize: "0.5rem" }}
                                  onClick={() => removeTag(index)}
                                  aria-label="Remove tag"
                                />
                              </div>
                            ))}
                            <input
                              type="text"
                              className="border-0 flex-grow-1"
                              style={{ outline: "none", minWidth: "100px" }}
                              placeholder={
                                tags.length === 0
                                  ? "Type and press space to add tags..."
                                  : ""
                              }
                              value={tagInput}
                              onChange={e => setTagInput(e.target.value)}
                              onKeyDown={e => {
                                if (e.key === " " || e.key === "Enter") {
                                  addTag(e)
                                } else if (e.key === "Backspace") {
                                  handleKeyDown(e)
                                }
                              }}
                              onBlur={validation.handleBlur}
                              id="tags"
                            />
                          </div>
                        </div>
                        <input
                          type="hidden"
                          name="tags"
                          value={validation.values.tags || ""}
                        />
                        {validation.touched.tags && validation.errors.tags ? (
                          <div className="invalid-feedback d-block">
                            {validation.errors.tags}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <CardTitle className="h4">Tickets</CardTitle>

                    {validation.values.tickets.map((row, idx) => (
                      <div className="row mb-3" key={idx}>
                        {/* Ticket Type */}
                        <div className="col-lg-3">
                          <label className="form-label">Ticket Type</label>
                          <input
                            type="text"
                            className={`form-control ${
                              validation.touched.tickets?.[idx]?.title &&
                              validation.errors.tickets?.[idx]?.title
                                ? "is-invalid"
                                : ""
                            }`}
                            {...validation.getFieldProps(
                              `tickets.${idx}.title`
                            )}
                          />
                          <div className="invalid-feedback">
                            {validation.errors.tickets?.[idx]?.title}
                          </div>
                        </div>

                        {/* Cost */}
                        <div className="col-lg-2">
                          <label className="form-label">Cost (Excl Taxes)</label>
                          <input
                            type="number"
                            className={`form-control ${
                              validation.touched.tickets?.[idx]?.cost &&
                              validation.errors.tickets?.[idx]?.cost
                                ? "is-invalid"
                                : ""
                            }`}
                            {...validation.getFieldProps(`tickets.${idx}.cost`)}
                          />
                          <div className="invalid-feedback">
                            {validation.errors.tickets?.[idx]?.cost}
                          </div>
                        </div>

                        {/* Seats */}
                        <div className="col-lg-2">
                          <label className="form-label">Seats</label>
                          <input
                            type="number"
                            className={`form-control ${
                              validation.touched.tickets?.[idx]?.seats &&
                              validation.errors.tickets?.[idx]?.seats
                                ? "is-invalid"
                                : ""
                            }`}
                            {...validation.getFieldProps(
                              `tickets.${idx}.seats`
                            )}
                          />
                          <div className="invalid-feedback">
                            {validation.errors.tickets?.[idx]?.seats}
                          </div>
                        </div>

                        {/* Is Child - dropdown */}
                        <div className="col-lg-2">
                          <label className="form-label">Is Child</label>
                          <select
                            className={`form-control ${
                              validation.touched.tickets?.[idx]?.is_child &&
                              validation.errors.tickets?.[idx]?.is_child
                                ? "is-invalid"
                                : ""
                            }`}
                            {...validation.getFieldProps(
                              `tickets.${idx}.is_child`
                            )}
                          >
                            <option value="">Select</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </select>
                          <div className="invalid-feedback">
                            {validation.errors.tickets?.[idx]?.is_child}
                          </div>
                        </div>
                        <Col lg={2} className="align-self-center d-grid mt-4">
                          {idx === 0 ? (
                            <Button
                              type="button"
                              color="success"
                              onClick={addTicketsRow}
                            >
                              Add More Ticket
                            </Button>
                          ) : (
                            <Button
                              type="button"
                              color="danger"
                              onClick={() => deleteTicketsRow(idx)}
                            >
                              Delete
                            </Button>
                          )}
                        </Col>
                      </div>
                    ))}

                    <div className="d-flex justify-content-center mt-3">
                      <Button
                        type="submit"
                        color="primary"
                        size="lg"
                        className="mt-3"
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddEvent
